export default {
  // TODO: Remove title if not used. Same with the translation.
  title: 'Mis carpetas',
  createFolder: 'Crear carpeta',
  tabs: {
    kimpleFolders: 'Carpetas Kimple',
    myFolders: 'Mis carpetas',
    sharedWithMe: 'Compartidas conmigo'
  },
  root: {
    Owner: 'Mis carpetas',
    Read: 'Compartidas conmigo',
    Edit: 'Compartidas conmigo'
  },
  noFolders: '¡Todavía no guardaste recursos!',
  clasifyResources: 'Anímate a clasificar en carpetas los recursos que te interesen.',
  noSharedFolders: 'Aún no te compartieron carpetas',
  noSharedFoldersDescription: 'Cuando tus colegas te otorguen acceso, ¡las verás aquí!',
  exploreResources: 'Explora recursos',
  createdOn: 'Creada el {date}',
  copiedOn: 'Copiada de Carpetas Kimple el {date}',
  by: 'Por {name}',
  you: 'ti',
  rename: 'Cambiar nombre',
  delete: 'Eliminar carpeta',
  managePermissions: 'Administrar permisos',
  share: 'Compartir',
  copy: 'Copiar',
  emptyResources: 'Aún no tienes recursos guardados en esta carpeta',
  deleteModal: {
    title: 'Eliminar carpeta',
    description: '¡Cuidado! Estás a punto de eliminar esta carpeta, ¿estás seguro que deseas eliminarla?',
    errorTitle: 'Error al eliminar carpeta',
    errorDescription: 'Debido a un error, no pudimos eliminar la carpeta.',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    ok: 'Entendido'
  },
  renameModal: {
    title: 'Renombrar carpeta',
    inputLabel: 'Nombre de la carpeta',
    inputPlaceholder: 'Por ejemplo: Robótica',
    errorTitle: 'Error al renombrar carpeta',
    errorDescription: 'Debido a un error no pudimos renombrar la carpeta. Recuerda que no se pueden repetir nombres.',
    errorEmptyName: 'Por favor, complete el nombre',
    save: 'Guardar',
    cancel: 'Cancelar',
    ok: 'Entendido'
  },
  createModal: {
    title: 'Crear carpeta',
    inputLabel: 'Nombre de la carpeta',
    inputPlaceholder: 'Por ejemplo: Robótica',
    errorTitle: 'Error al crear carpeta',
    errorDescription: 'Debido a un error no pudimos crear la carpeta. Recuerda que no se pueden repetir nombres.',
    save: 'Crear carpeta',
    cancel: 'Cancelar',
    ok: 'Entendido'
  },
  shareModal: {
    title: 'Comparte esta carpeta',
    confirmTitle: '¿Estás seguro que quieres compartir la carpeta a estos integrantes?',
    shareDescription: 'Al presionar “Compartir” se enviará a:',
    warning: 'IMPORTANTE: Algunos de los integrantes recibirán la carpeta al aceptar la invitación a la escuela.',
    cancel: 'Cancelar',
    success: '¡Has compartido la carpeta con éxito!',
    description: 'Puedes compartir este carpeta sólo con las personas en tu red de escuela',
    owner: 'Propietario'
  },
  removeAccessModal: {
    title: '¿Estás seguro que deseas quitar el acceso a la carpeta?',
    subtitle: 'Al continuar quitarás el acceso a la carpeta a los siguientes usuarios:'
  },
  seeMore: 'VER MÁS',
  backToFolders: 'Volver',
  kimpleRecommends: 'Kimple te recomienda',
  managePermissionsModal: {
    title: 'Administrar esta carpeta',
    save: 'Guardar',
    empty: 'Esta carpeta no ha sido compartida',
    owner: 'Es dueño'
  },
  owner: 'Dueño',
  edit: 'Editor',
  read: 'Visualización',
  removeFolderAccess: 'Quitar acceso',
  ageRange: '{min} a {max} años',
  orderResources: 'Personalizar el orden de los recursos',
  addDescription: 'Agrega una descripción a esta carpeta...',
  cancel: 'Cancelar',
  save: 'Guardar'
}

export const en = {
  title: 'My folders',
  createFolder: 'Create folder',
  tabs: {
    kimpleFolders: 'Kimple Folders',
    myFolders: 'My folders',
    sharedWithMe: 'Shared with me'
  },
  root: {
    Owner: 'My folders',
    Read: 'Shared with me',
    Edit: 'Shared with me'
  },
  noFolders: 'You haven\'t saved any resources yet!',
  clasifyResources: 'Classify the resources you\'re interested in into folders',
  noSharedFolders: 'Folders have not yet been shared with you',
  noSharedFoldersDescription: 'When your colleagues give you access, you will see them here!',
  exploreResources: 'Browse resources',
  createdOn: 'Created on {date}',
  copiedOn: 'Copied from Kimple Folders on {date}',
  by: 'By {name}',
  you: 'you',
  rename: 'Change name',
  delete: 'Delete folder',
  managePermissions: 'Manage permissions',
  share: 'Share',
  copy: 'Copy',
  emptyResources: 'You don\'t have resources saved in this folder yet',
  deleteModal: {
    title: 'Delete folder',
    description: 'Careful! You\'re about to delete this folder, are you sure you want to delete it?',
    errorTitle: 'Failed to delete folder',
    errorDescription: 'There was an error, the folder wasn\'t deleted.',
    delete: 'Delete',
    cancel: 'Cancel',
    ok: 'Ok'
  },
  renameModal: {
    title: 'Rename folder',
    inputLabel: 'Folder name',
    inputPlaceholder: 'For example: Robotics',
    errorTitle: 'Failed to rename folder',
    errorDescription: 'There was an error, the folder wasn\'t renamed. Remember you can\'t repeat names.',
    errorEmptyName: 'Please, complete the name',
    save: 'Save',
    cancel: 'Cancel',
    ok: 'Ok'
  },
  createModal: {
    title: 'Create folder',
    inputLabel: 'Folder name',
    inputPlaceholder: 'For example: Robotics',
    errorTitle: 'Failed to create folder',
    errorDescription: 'There was an error, the folder wasn\'t created. Remember you can\'t repeat names.',
    save: 'Create folder',
    cancel: 'Cancel',
    ok: 'Ok'
  },
  shareModal: {
    title: 'Share this folder',
    confirmTitle: 'Are you sure you want to share the folder to these members?',
    shareDescription: 'When you click "Share", it will be sent to:',
    warning: 'IMPORTANT: Some of the members will receive the folder when they accept the invitation to the school.',
    cancel: 'Cancel',
    success: 'You have successfully shared the folder!',
    description: 'You can share this folder only with people in your school network',
    owner: 'Owner'
  },
  removeAccessModal: {
    title: 'Are you sure you want to remove access to the folder?',
    subtitle: 'By continuing you will remove access to the folder for the following users:'
  },
  seeMore: 'SEE MORE',
  backToFolders: 'Back',
  kimpleRecommends: 'Kimple recommends',
  managePermissionsModal: {
    title: 'Manage this folder',
    save: 'Save',
    empty: 'This folder hasn\'t been shared',
    owner: 'Is owner'
  },
  owner: 'Owner',
  edit: 'Editor',
  read: 'Viewing',
  removeFolderAccess: 'Remove access',
  ageRange: '{min} to {max} y/o',
  orderResources: 'Customize resource order',
  addDescription: 'Add description to this folder...',
  save: 'Save',
  cancel: 'Cancel'
}

export const ca = {
  title: 'Les meves carpetes',
  createFolder: 'Crea carpeta',
  tabs: {
    kimpleFolders: 'Carpetes Kimple',
    myFolders: 'Les meves carpetes',
    sharedWithMe: 'Compartides amb mi'
  },
  root: {
    Owner: 'Les meves carpetes',
    Read: 'Compartides amb mi',
    Edit: 'Compartides amb mi'
  },
  noFolders: 'Encara no has desat cap recurs!',
  clasifyResources: 'Anima\'t a classificar els recursos que t\'interessin en carpetes.',
  noSharedFolders: 'Encara no s\'han compartit carpetes amb tu',
  noSharedFoldersDescription: 'Quan els teus companys et permetin l\'accés, les veuràs aquí!',
  exploreResources: 'Explora recursos',
  createdOn: 'Creada el {date}',
  copiedOn: 'Copiada de Carpetes Kimple el {date}',
  by: 'Per {name}',
  you: 'tu',
  rename: 'Canvia el nom',
  delete: 'Elimina carpeta',
  managePermissions: 'Administra els permisos',
  share: 'Comparteix',
  copy: 'Copiar',
  emptyResources: 'Encara no tens recursos desats en aquesta carpeta',
  deleteModal: {
    title: 'Elimina carpeta',
    description: 'Compte! Estàs a punt d\'eliminar aquesta carpeta, estàs segur que la vols eliminar?',
    errorTitle: 'Error eliminant carpeta',
    errorDescription: 'Degut a un error, no hem pogut eliminar la carpeta.',
    delete: 'Elimina',
    cancel: 'Cancel·la',
    ok: 'Entesos'
  },
  renameModal: {
    title: 'Canvia el nom de la carpeta',
    inputLabel: 'Nom de la carpeta',
    inputPlaceholder: 'Per exemple: Robòtica',
    errorTitle: 'Error canviant el nom de la carpeta',
    errorDescription: 'Degut a un error no hem pogut canviar el nom de la carpeta. Recorda que no es poden repetir noms.',
    errorEmptyName: 'Si us plau, escriu el nom',
    save: 'Desa',
    cancel: 'Cancel·la',
    ok: 'Entesos'
  },
  createModal: {
    title: 'Crea carpeta',
    inputLabel: 'Nom de la carpeta',
    inputPlaceholder: 'Per exemple: Robòtica',
    errorTitle: 'Error creant carpeta',
    errorDescription: 'Degut a un error no hem pogut crear la carpeta. Recorda que no es poden repetir noms.',
    save: 'Crea carpeta',
    cancel: 'Cancel·la',
    ok: 'Entesos'
  },
  shareModal: {
    title: 'Comparteix aquesta carpeta',
    confirmTitle: 'Estàs segur que vols compartir la carpeta a aquests integrants?',
    shareDescription: 'En prémer “Compartir” s\'enviarà a:',
    warning: 'IMPORTANT: Alguns dels integrants rebran la carpeta en acceptar la invitació a l\'escola.',
    cancel: 'Cancelar',
    success: 'Has compartit la carpeta amb èxit!',
    description: 'Només pots compartir aquesta carpeta amb les persones de la xarxa de la teva escola ',
    owner: 'Propietari'
  },
  removeAccessModal: {
    title: 'Estàs segur que desitges llevar l\'accés a la carpeta?',
    subtitle: 'En continuar llevaràs l\'accés a la carpeta als següents usuaris:'
  },
  seeMore: 'ENSENYA\'M MÉS',
  backToFolders: 'Torna',
  kimpleRecommends: 'Kimple et recomana',
  managePermissionsModal: {
    title: 'Administra aquesta carpeta',
    save: 'Desa',
    empty: 'Aquesta carpeta no ha estat compartida',
    owner: 'N\'ets propietari'
  },
  owner: 'Propietari',
  edit: 'Editor',
  read: 'Visualització',
  removeFolderAccess: 'Llevar accés',
  ageRange: '{min} a {max} anys',
  orderResources: 'Personalitzar l\'ordre dels recursos',
  addDescription: 'Afegir una descripció a aquesta carpeta...',
  save: 'Crea carpeta',
  cancel: 'Cancel·la'
}
